export default __webpack_public_path__ + "static/media/appInfo.776781b3.svg";